import { render } from "./Resume.vue?vue&type=template&id=7332d0dc"
import script from "./Resume.vue?vue&type=script&lang=ts"
export * from "./Resume.vue?vue&type=script&lang=ts"

import "./Resume.vue?vue&type=style&index=0&id=7332d0dc&lang=css"
script.render = render

export default script